import { render, staticRenderFns } from "./Form19CaseInformation.vue?vue&type=template&id=101b64c8&scoped=true"
import script from "./Form19CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form19CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b64c8",
  null
  
)

export default component.exports